import { useI18N } from '@tm/client-form/src/hooks/useI18n'
import { useTitle } from '@tm/client-form/src/hooks/useTitle'
import { Field } from '@tm/shared-lib/src/field'
import { ViewProps } from '../types'
import { DefaultView } from './DefaultView'

/**
 * Flatten fields to get first field label
 * if first question is fieldset
 */
const flattenFields = (fields: Field[]): Field[] => {
  return fields.reduce((acc, field) => {
    if ('fields' in field && field.fields) {
      return [...acc, ...flattenFields(field.fields)]
    }

    return [...acc, field]
  }, [] as Field[])
}

const getTitle = (fields: Field[]) => {
  const [firstField] = flattenFields(fields)
  if (!firstField) return undefined

  if ('label' in firstField && firstField.label) {
    return firstField.label
  }

  if ('inputLabel' in firstField && firstField.inputLabel) {
    return firstField.inputLabel
  }

  return undefined
}

export function DefaultLoader(props: ViewProps) {
  const { fields } = props
  const { tt } = useI18N()
  useTitle(tt(getTitle(fields)))
  return <DefaultView {...props} />
}
